export const POSTAL_CODE_LENGTH = 6;
export const VERIFICATION_CODE_LENGTH = 4;
